import React, { useState } from 'react';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { IconContext } from 'react-icons';
import { userLogin } from "../../services/login-api.js";
import { global_var } from "../../services/login-config.js"
import { trackEvent } from '../../analytics/analytics_login.js';
import CsproCarousel from './carousel.js';

const CsproLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [usernameTouched, setUsernameTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  const handleUsernameChange = (event) => {
      const newUsername = event.target.value;
      setUsername(newUsername);
      validateForm(newUsername, password);
      setUsernameTouched(true);
      setErrorMessage("");
  };

  const handlePasswordChange = (event) => {
      const newPassword = event.target.value;
      setPassword(newPassword);
      validateForm(username, newPassword);
      setPasswordTouched(true);
      setErrorMessage("");
  };

  const validateForm = (newUsername, newPassword) => {
      const isUsernameValid = newUsername.trim() !== '';
      const isPasswordValid = newPassword.length >= 5;

      setIsFormValid(isUsernameValid && isPasswordValid);
  };

  const togglePasswordVisibility = () => {
      setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSubmit = (event) => {
      event.preventDefault();
      if (isFormValid) {
          const loginObj = {
              username: username.toLowerCase(),
              password: password,
              company_id: global_var.companyId
          }
          loginUserHandler(loginObj);

          async function loginUserHandler(loginObj) {
              try {
                  const response = await userLogin(loginObj);
                  // Handle the response here
                  if (response.status === 200 && response.data && response.data.access_token) {
                      trackEvent('login_button_clicked',{status:"login_successful"});

                      let domainName = 'http://' + window.location.host.replace(/.login/g,'');
                      if (response.data.active_user_data.fkRoleId === 3) {
                          domainName += '/candidate/#/home/redirect';
                        //   domainName = 'http://baabtra.test99lms.com:9001/#/home/redirect';
                          trackEvent("user_role_wise_login",{role: response.data.active_user_data.fkRoleName});
                      } else {
                          domainName += '/company/#/home/redirect';
                        //   domainName = 'http://baabtra.test99lms.com:9001/#/home/redirect';
                          trackEvent("user_role_wise_login",{role: response.data.active_user_data.fkRoleName});
                      }
                      domainName += '?access_token=' + response.data.access_token;
                      localStorage.setItem('token', response.data.access_token)
                      window.location.href = domainName;

                  }
              } catch (error) {
                  trackEvent('login_button_clicked',{status:"login_failed"});
                  // Handle errors here
                  if (error.response) {
                      const errorMessage = error.response.data.message;
                      trackEvent('login_failure_reason',{message:errorMessage});
                      setErrorMessage(errorMessage);
                  }

              }
          }

      };
   }
  return (
    <div className='container-fluid'>
    <div className='row background' >
        <div className='col-md-6 col-12  mx-md-auto ps-5 ps-md-0 cspro_background' style={{ zIndex: '1' }}>
        {window.innerWidth <= 991 &&  global_var.logo ?(
        <img 
          src='https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/companyLogo/cybersquareProWhitelogo.png'
          alt="cyberSquareProWhite" /> 
        ): null}
            <div className='col-md-12 col-12 d-flex justify-content-end move-to-right '>
                <div className='col-md-7 col-7' >
                    <p className='responsive-text' style={{ marginTop: '-135px', paddingBottom: '10px' }}>
                       <span className='banner_text'>Elevate Your Skills with our Internship Programs.</span></p>
 
                    <CsproCarousel />   
                    
                </div>
                <div className='col-md-5 col-5'>
                    
                </div>
            </div>
        </div>

        <div className='col-md-6 col-12 d-flex justify-content-center align-items-center'>
            <div className='col-md-10 col-12 p-md-5 p-4 mt-md-5'>
                 {window.innerWidth >= 991 && global_var.logo? (<img src={global_var.logo} alt="cyberSquarePro" width={'50%'} style={{ marginLeft: '-14px'}} />) :null}
                <form data-testid='loginForm' onSubmit={handleSubmit}>
                      <h1 className='form_text'> Welcome to Your Digital Workspace!</h1>
                    <div className="form-group mb-md-3 mb-4 mt-md-5">
                      
                        <input
                            type="text"
                            id="userName"
                            className={`new-form-control rounded-3 border-0 input-height ${username.trim() === '' ? 'is-invalid' : ''}`}
                            placeholder="Username"
                            value={username}
                            onChange={handleUsernameChange}
                            style={{ boxShadow:' 0 0 0 0.05rem #d0cdcb'}}
                            required
                        />
                        {usernameTouched && username.trim() === '' && <label data-testid="username-error" className="invalid-feedback">Enter your username to proceed.</label>}
                    </div>
                    <div className="form-group md-mb-4 mb-4">
                      
                        <div className='input-group'>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id='password'
                                className={`new-form-control rounded-3 border-0 input-height ${password.length < 5 ? 'is-invalid' : ''}`}
                                placeholder='Enter password'
                                value={password}
                                onChange={handlePasswordChange}
                                style={{ boxShadow:' 0 0 0 0.05rem #d0cdcb'}}
                                required
                            />

                            {password.length > 0 && (
                                <div className='input-group-append'>
                                    <IconContext.Provider value={{ size: '1.5em' }}>
                                        <span className='input-group-text' onClick={togglePasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                            {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                        </span>
                                    </IconContext.Provider>
                                </div>
                            )}
                            {passwordTouched && password.length < 5 && password.trim() !== '' && <div className="invalid-feedback">Password must be at least 5 characters.</div>}
                            {passwordTouched && password.trim() === '' && <div data-testid="password-error" className="invalid-feedback">Enter your password to proceed.</div>}
                            {errorMessage && (
                                <div style={{ color: 'red', marginTop: '10px' }}>
                                    {errorMessage}
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="text-center mb-3 mb-md-2 mt-5 mt-md-0 pt-4">
                        <button type="submit" className="btn btn-warning form-control"  style={{
                            backgroundColor: "#FF0000",
                            color: "white",
                            borderRadius: "10px",
                            display: "block",
                            boxShadow: isFormValid
                                ? "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)"
                                : "0 4px 6px rgba(255, 110, 98, 0.5), 0 1px 3px rgba(255, 110, 98, 0.5)",
                            height: '50px'
                        }} data-testid='signInButton' disabled={!isFormValid}>Sign in</button>
                    </div>
                    <div className="text-center mt-5 mt-md-0">
                                <a href='/otpLogin' className='text-light-blue text-decoration-none'>Sign in using OTP</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
  );
}

export default CsproLogin;